var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:[{'blue--text': _vm.punkte[0] >= 3},
            {'success--text': _vm.punkte[0] >= 2 && _vm.punkte[0] < 3},
            {'primary--text': _vm.punkte[0] < 2},
            ]},[_vm._v(_vm._s(_vm.punkte[0]))]),_vm._v(" / "),_c('span',{class:[{'blue--text': _vm.punkte[1] === 1},
                                {'success--text': _vm.punkte[1] === 0.5},
                                {'primary--text': _vm.punkte[1] === 0},
                                ]},[_vm._v(_vm._s(_vm.punkte[1]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }